import React from 'react';
import { FormattedDate } from 'react-intl';
import TimeAgo from 'react-timeago';
import { DateContainer } from './styles';
const DAY = 24 * 60 * 60 * 1000;
const Time = ({ className = '', date }) => {
    const delta = Date.now() - date;
    return (React.createElement(DateContainer, { className: className }, delta < DAY ? React.createElement(TimeAgo, { date: date }) : React.createElement(FormattedDate, { value: date })));
};
export default Time;
//# sourceMappingURL=index.js.map